export const MetadataKeys = {
  propertyLevelInfo: 'PropertyLevelInfo'
};
